import { Menu as ChakraMenu, Portal } from '@chakra-ui/react';
import { forwardRef, useMemo } from 'react';

import { MenuDefaultProps, type MenuProps } from './Menu.types';

const Menu = forwardRef<HTMLDivElement, MenuProps>(({ trigger, items, ...props }, ref) => {
  const menuItems = useMemo(
    () =>
      items?.map(({ value, label, icon, disabled, onClick }) => (
        <ChakraMenu.Item key={value} value={value} disabled={disabled} onClick={onClick}>
          {icon}
          {label}
        </ChakraMenu.Item>
      )) || null,
    [items]
  );

  return (
    <ChakraMenu.Root {...props}>
      <ChakraMenu.Trigger asChild>{trigger}</ChakraMenu.Trigger>
      <Portal>
        <ChakraMenu.Positioner>
          <ChakraMenu.Content ref={ref}>{menuItems}</ChakraMenu.Content>
        </ChakraMenu.Positioner>
      </Portal>
    </ChakraMenu.Root>
  );
});

Menu.displayName = 'Menu';
Menu.defaultProps = MenuDefaultProps;

export { Menu };
